import { memo } from 'react'
import BaseReportTable from './BaseReportTable'
import { DEFAULT_ROWS } from '../constants'

function ProductWiseTable({
  columns,
  rows,
  loading,
  pagination,
  sortBy,
  sortOrder,
  onSort,
}) {
  return (
    <BaseReportTable
      columns={columns}
      rows={rows}
      loading={loading}
      limit={pagination.limit || DEFAULT_ROWS}
      emptyMessage="No products found"
      sortBy={sortBy}
      sortOrder={sortOrder}
      onSort={onSort}
      getRowKey={(row) => `${row.productId}-${row.orgId}`}
    />
  )
}

export default memo(ProductWiseTable)
